import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import { remCss, lang, withRouter, formatDuration } from 'src/helpers';
import { MCButton, TextField } from 'src/components/basic';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';

const intervalId = 'EmailVerification';

class VerifyEmailPopup extends BaseComponent {
  state = { sent: false, resend: false, loading: true, id: null, msg: null };

  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  requestVerification = (e) => {
    e.preventDefault();

    model.requestVerification((err, res) => {
      if (res?.ok) {
        this.setState({ resend: false, sent: true });
      } else if (res?.expired) {
        model.setState({ resetExpired: res.expired });
        this.timer(() => model.state.resetExpired > Date.now(), intervalId);
      }
    });
  };

  render() {
    const { closeBtn } = this.props;
    let { sent } = this.state;

    const apiStateId = 'requestVerification';
    const { handleChange, handleBlur } = model;
    const createState = model.getApiState(apiStateId);
    let { loading, invalid, error, errorMessage } = createState;

    const { blocked, expiredIn } = model.getBlock();

    if (error === 'BLOCKED') errorMessage = '';

    if (error === 'EMAIL_TAKEN') {
      invalid['email'] = errorMessage;
      error = null;
    }
    let blockedInMin = Math.ceil(expiredIn / 60);
    blockedInMin = `${blockedInMin} ${blockedInMin > 2 ? 'minutes' : 'minute'}`;

    return (
      <div className='mc-popup-contain' style={{ width: remCss(600) }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t(LANG_CONST.verify_your_email)}</div>
          {closeBtn}
        </div>
        <form
          className='mc-modal-body mc-form'
          style={{ display: 'flex', flexDirection: 'column', gap: 20 }}
          onSubmit={this.requestVerification}
        >
          {error && <p className='mc-error'>{errorMessage}</p>}
          <div className='mc-value-418'>{lang.t(LANG_CONST.text.check_inbox_email)}</div>
          <TextField
            template={6}
            name={'email'}
            value={model.input('email')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              model.setStateSilent({ resetExpired: 0 });
              handleChange(n, v);
            }}
            onBlur={handleBlur}
            label={LANG_CONST.email_address}
            invalid={invalid}
          />
          {blocked && (
            <div className={'mc-label-418'}>
              {lang.t(LANG_CONST.notice.verify_code_sent_email, { blockedInMin })}
            </div>
          )}

          <MCButton
            large
            type='submit'
            radius
            disabled={blocked || loading}
            loading={loading}
            primary
            dark={!blocked}
            light={blocked}
            label={
              blocked
                ? lang.t(LANG_CONST.buttons.resend_in, { duration: formatDuration(expiredIn) })
                : lang.t(LANG_CONST.buttons.resend)
            }
          />

          {sent && !blocked && (
            <div>
              <div className='mc-value-418'>
                <span>{lang.t(LANG_CONST.text.verification_email_sent)}</span>
              </div>
            </div>
          )}
        </form>
      </div>
    );
  }
}

export default withRouter(VerifyEmailPopup);
